<template>
  <div class="flex flex-wrap flex-col gap-xs align-items-center">
    <tag :tag="tag"></tag>
    <a v-if="!confirm" @click="confirm = true" class="btn btn-default">
      <span v-if="tag.archived">Restore {{ tag.abbreviation }}</span>
      <span v-else>Archive {{ tag.abbreviation }}</span>
    </a>
    <div v-else class="archive-form should-dim modify-form m-t-sm card-bordered-dashed text-left">
      <div>
        <p>
          Are you sure you want to {{ actionVerb }}{{ tag.abbreviation }}?
        </p>
      </div>
      <div class="">
        <small v-show="error"><span class="text-danger">{{ errorMessage }}</span></small>
        <br/>
        <button v-on:click="confirm = false" class="btn btn-default m-b-sm m-r-sm">Cancel</button>
        <ladda-button @lbClicked="toggleArchivePressed" el-class="btn-danger m-b-sm" :loading="loading">
          Yes, {{ actionVerb }} {{ tag.abbreviation }}
        </ladda-button>
      </div>
    </div>
  </div>
</template>
<script>
import Tag from "../../shared/tag.vue";
import LaddaButton from "../../shared/ladda_button.vue";
export default {
  name: "archive-tag-form",
  components: { Tag, LaddaButton },
  props: {
    tag: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      confirm: false,
      error: false,
      errorMessage: "Error, please try again later or contact support.",
    };
  },
  computed: {
    actionVerb() {
      return this.tag.archived ? "restore" : "archive";
    },
  },
  methods: {
    toggleArchivePressed: _.throttle(function () {
      const vm = this;
      // If this is a duplicate request, just return
      if (vm.loading === true) {
        return;
      }
      vm.loading = true;

      const params = {
        tag: {
          archived: !vm.tag.archived,
        },
      };
      const url = vm.$apiService.tagUrl(vm.tag.id);
      axios.put(url, params)
        .then((response) => {
          vm.loading = false;
          vm.$notificationManager.$emit('show-toast', vm.tag.archived ? 'Tag archived' : 'Tag restored', true);
          // only reload teh page after a half second delay
          setTimeout(() => {
            window.location.reload();
          }, 500);
        })
        .catch((error) => {
          vm.loading = false;
          vm.errorMessage = vm.parseErrorResponse(error);
          vm.error = true;
        });
    }, 500),
  }
};
</script>
